import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Formsy from 'formsy-react';
import moment from 'moment';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import DateBox from '@sophocles/components/FormFields/DateBox';
import TextBox from '@sophocles/components/FormFields/TextBox';
import { patchSiteMaintenanceLog } from '@sophocles/entities/SiteMaintenanceLog';

class ResolveMaintenanceLogDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      canSubmit: true,
    };
  }

  submit = values => {
    const { patchEntry, user, log, onResult, startLoading, endLoading } = this.props;

    values.resolved_by = user.get('id', 0);
    values.date_resolved = moment(values.date_resolved).format('YYYY-MM-DD');
    const log_id = log.get('id', 0);
    if (values.resolved_by !== 0 && log_id != 0) {
      if (typeof startLoading === 'function') {
        startLoading();
      }
      patchEntry(log_id, values).then(res => {
        if (typeof onResult === 'function') {
          onResult(res);
        }
        if (typeof endLoading === 'function') {
          endLoading();
        }
      });
      this.myRef.reset();
    }
  };

  enableButton = () => this.setState({ canSubmit: true });

  disableButton = () => this.setState({ canSubmit: false });

  onSubmit = () => {
    this.props.closeDialog();
    this.myRef.submit();
  };

  render() {
    const { user, closeDialog, open, log, t } = this.props;

    // let timezone = (site.get('time_zone') ? "UTC" : "America/New_York" );
    const issueUser = log.get('entered_by', null);
    const issue = log.get('issue');

    const dateReported = moment(log.get('date_reported', new Date()));
    const displayDateReported = dateReported.format('L');

    // const now = moment().format('L');
    const fullName = issueUser ? issueUser.get('first_name', '') + ' ' + issueUser.get('last_name', '') : 'System';

    const today = new Date();

    const form = (
      <Formsy
        ref={input => (this.myRef = input)}
        onSubmit={this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        className=""
        key="add-maintenance-log"
      >
        <div className="maintenance-log-box-row-title">
          <div>{fullName}</div>
          <div>
            {t('general.timestamp')}: {displayDateReported}
          </div>
        </div>

        <div className="maintenance-log-box-row-body">
          <div style={{ flexGrow: 1 }}>
            <div className="maintenance-log-box-issue-display">
              <b>{t('sites.issue')}:</b> {issue}
            </div>
          </div>
        </div>

        <DateBox
          label={t('sites.dateOfResolution')}
          value={today}
          minDate={dateReported.toDate()}
          maxDate={today}
          name="date_resolved"
        />

        <TextBox
          value=""
          name="resolution"
          title={t('sites.resolution')}
          required={true}
          multiline={true}
          rows={1}
          fullWidth={true}
        />

        <TextBox
          value=""
          name="resolved_technician"
          title={t('sites.technician')}
          rows={1}
          fullWidth={true}
          validations={{
            max100: function (values, value) {
              return value.length <= 100 ? true : 'Must be 100 characters or less';
            },
          }}
        />
      </Formsy>
    );

    const actions = [
      <Button key="cancel" variant="outlined" onClick={closeDialog}>
        {t('actions.cancel')}
      </Button>,
      <Button key="submit" variant="contained" disabled={!this.state.canSubmit} onClick={this.onSubmit}>
        {t('actions.submit')}
      </Button>,
    ];

    return (
      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>{t('sites.resolveMaintenanceEntry')}</DialogTitle>
        <DialogContent dividers>{form}</DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    patchEntry: (maintenanceLog_id, values) => dispatch(patchSiteMaintenanceLog(maintenanceLog_id, values)),
  };
}

const ResolveMaintenanceLogDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ResolveMaintenanceLogDialog));

export default ResolveMaintenanceLogDialogContainer;
